import { AppRouteRecordRaw } from '@/router/types'

export const agreementSignHistory: AppRouteRecordRaw[] = [
  {
    path: 'agreementSignHistory',
    name: 'AgreementSignHistory',
    component: () => import('@/views/agreementSignHistory/index.vue'),
    meta: {
      title: '签署协议记录'
    }
  }
]
